var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAth(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 21,
    viewBox: "0 0 58 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.96592 20.3636H1.11163e-05L6.7216 1.04904e-05H14.2784L21 20.3636H15.0341L10.5796 5.60797H10.4205L5.96592 20.3636ZM4.85228 12.3296H16.0682V16.4659H4.85228V12.3296ZM19.8342 4.45456V1.04904e-05H37.533V4.45456H31.408V20.3636H25.9592V4.45456H19.8342ZM39.6136 20.3636V1.04904e-05H45.1421V7.95456H52.4602V1.04904e-05H57.9886V20.3636H52.4602V12.4091H45.1421V20.3636H39.6136Z",
    fill: "#AAB0B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAth);
export default __webpack_public_path__ + "static/media/ATH.fd0985a8b59936f2b25a9276bc718e07.svg";
export { ForwardRef as ReactComponent };